import { rux } from './../../../lib/rux.js'
import router from './../../router'
const AuthStore = {
  namespaced: true,
  state: {
    isAuth: false,
    userProfile: {}
  },
  actions: {
    /**
       * Login via email and password
       * @async
       * @param {Object} form - has the fields email and password
       * @param {string} form.password - the password to sign in with
       * @param {string} form.email - the email to sign in with
       * @commitsTo SetAuth
       */
    async login ({ dispatch, commit }, form) {
      try {
        // Get the user profile that is returned on succesful login.
        // Bad login requests are caught below
        const { user } = await rux.loginEmail(form.email, form.password)
        // Add the user profile to the store
        dispatch('fetchUserProfile', user)
        // Set the user is allowed access
        commit('SETAUTH', true)
      } catch (error) {
        // Catch the errors and add them to error handler
        dispatch('error', error, { root: true })
      }
      return null
    },
    /**
       * @summary Logs out of the app and moves them back to the login screen
       * @commitsTo SETAUTH, SETRUXLIST, SETUSERPROFILE
       */
    async logout ({ dispatch, commit }) {
      // Log Out
      await rux.logout()
      // Set the auth to false
      commit('SETAUTH', false)
      // Clear the rux list
      commit('rux/SETRUXLIST', [], { root: true })
      // Clear the user profile
      commit('SETUSERPROFILE', {})
      // Take them
      router.push('/login')
    },
    /**
       * @summary Gets the user profile from the db and adds to the store
       * @CommitsTo SETUSERPROFILE
       */
    async fetchUserProfile ({ dispatch, commit }) {
      if (rux.isAuth()) {
        let userProfile = await rux.getUserProfile()
        if (!userProfile) {
          userProfile = { name: 'N/A', email: 'N/A' }
        }
        commit('SETUSERPROFILE', userProfile)
      }
    },
    /**
       * @summary Creates an account using email and password, Which logs the user in as well.
       * @param {object} form
       * @param {string} form.email - The email to create the account with
       * @param {string} form.password - The password associated the account
       * @commits SETAUTH
       */
    async signUp ({ dispatch, commit }, form) {
      try {
        // Create the user in firebase
        const { user } = await rux.createAccountWithEmail(form.email, form.password)
        // Create the user profile
        await rux.createAndUpdateUserProfile({ email: form.email, name: form.name })
        // now add name to the user profie section
        dispatch('fetchUserProfile', user)
        // Set the auth property so the user once the user is successfully logged in
        commit('SETAUTH', true)
      } catch (error) {
        // Use the global error handle to handle the error
        dispatch('error', error, { root: true })
      }
    },
    /**
       * @summary Reset the password of the email passed in.
       * @param {string} email - the email of the account to reset the password for
       */
    async resetPassword ({ dispatch, commit }, email) {
      try {
        // Reset the password here. This takes care of the reset and sending the email
        await rux.resetPasswordViaEmail(email)
        commit('rux/SUCCESS', 'Password Reset Sent', { root: true })
      } catch (error) {
        // Use the global error handle to handle the error
        dispatch('error', error, { root: true })
      }
    },
    /**
       * @summary - Checks whether the user is logged in. This is useful for when the app starts up as if the person
       * is already logged in to the app we can just set Auth to true immediately
       * @commit SETAUTH
       */
    async checkAuth ({ commit }) {
      if (rux.isAuth()) {
        commit('SETAUTH', true)
      }
    }
  },
  mutations: {
    // Update the User Profile
    SETUSERPROFILE (state, val) {
      state.userProfile = val
    },
    // Sets whether the user is authenticated
    SETAUTH (state, val) {
      state.isAuth = val
    }
  }
}
export { AuthStore }
